// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard.scss */
* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #f6f8fc;
  color: #111827;
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

button,
input {
  font-family: inherit;
}

/* =========================================================
   DASHBOARD PAGE
========================================================= */
.dashboard-page {
  width: 100%;
  min-height: 100vh;
  padding: 16px 18px;
  background: radial-gradient(circle at top right, rgba(37, 99, 235, 0.035), transparent 28%), #f6f8fc;
}

/* =========================================================
   HEADER
========================================================= */
.dashboard-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #e6edf7;
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07);
  backdrop-filter: blur(14px);
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 280px;
}
.topbar-left .live-badge {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  flex: 0 0 46px;
  border-radius: 15px;
  background: linear-gradient(135deg, #0ea5e9, #2563eb);
  color: #ffffff;
  font-size: 12px;
  font-weight: 900;
  box-shadow: 0 10px 22px rgba(37, 99, 235, 0.24);
}
.topbar-left h1 {
  margin: 0;
  color: #111827;
  font-size: 24px;
  line-height: 1.15;
  font-weight: 700;
}
.topbar-left p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 12px;
  font-weight: 650;
}

.topbar-filters {
  display: flex;
  align-items: end;
  justify-content: flex-end;
  gap: 10px;
  flex-wrap: wrap;
}

.field-box {
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.field-box label {
  color: #3f4a5b;
  font-size: 12px;
  font-weight: 700;
}
.field-box input {
  width: 140px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid #d7e0ed;
  border-radius: 10px;
  outline: none;
  background: #ffffff;
  color: #111827;
  font-size: 12px;
  font-weight: 750;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}
.field-box input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
}
.field-box.target-box input {
  width: 160px;
}

.refresh-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  height: 36px;
  border: none;
  border-radius: 8px;
  padding: 0 16px;
  background: #0047ab;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}
.refresh-button:hover:not(:disabled) {
  background: #020617;
  transform: translateY(-1px);
  box-shadow: 0 7px 18px rgba(2, 6, 23, 0.15);
}
.refresh-button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* =========================================================
   LIVE DASHBOARD STATUS
========================================================= */
.dashboard-live-status {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 58px;
  margin-top: 12px;
  padding: 10px 14px;
  border: 1px solid rgba(37, 99, 235, 0.1);
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(239, 246, 255, 0.72));
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.035);
  transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
}

.dashboard-live-status-left {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 11px;
}
.dashboard-live-status-left > div {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dashboard-live-status-left strong {
  color: #0f172a;
  font-size: 12px;
  line-height: 1.35;
  font-weight: 750;
}
.dashboard-live-status-left small {
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  line-height: 1.4;
  font-weight: 550;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-live-dot {
  position: relative;
  width: 9px;
  height: 9px;
  flex: 0 0 9px;
  border-radius: 50%;
  background: #16a34a;
  box-shadow: 0 0 0 4px rgba(22, 163, 74, 0.1);
  animation: dashboardLivePulse 2s ease-out infinite;
}
.dashboard-live-dot.refreshing {
  background: #f59e0b;
  box-shadow: 0 0 0 4px rgba(245, 158, 11, 0.12);
  animation: dashboardRefreshingPulse 1.2s ease-out infinite;
}

@keyframes dashboardLivePulse {
  0% {
    box-shadow: 0 0 0 0 rgba(22, 163, 74, 0.32);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(22, 163, 74, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(22, 163, 74, 0);
  }
}
@keyframes dashboardRefreshingPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.34);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(245, 158, 11, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);
  }
}
.dashboard-live-status-right {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 9px;
}

.dashboard-refresh-state {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 55px;
  height: 25px;
  padding: 0 9px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.dashboard-refresh-state.is-live {
  border: 1px solid rgba(22, 163, 74, 0.15);
  background: rgba(22, 163, 74, 0.08);
  color: #15803d;
}
.dashboard-refresh-state.is-refreshing {
  border: 1px solid rgba(245, 158, 11, 0.18);
  background: rgba(245, 158, 11, 0.09);
  color: #b45309;
}

.dashboard-refresh-spinner {
  width: 17px;
  height: 17px;
  flex: 0 0 17px;
  border: 2px solid rgba(37, 99, 235, 0.18);
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: dashboardRefreshSpin 0.75s linear infinite;
}

@keyframes dashboardRefreshSpin {
  to {
    transform: rotate(360deg);
  }
}
/* =========================================================
   API ERROR ALERT
========================================================= */
.dashboard-alert {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px solid #fecdd3;
  border-radius: 14px;
  background: #fff1f2;
  color: #991b1b;
  font-size: 13px;
}
.dashboard-alert strong {
  font-weight: 900;
}
.dashboard-alert span {
  flex: 1 1;
  font-weight: 600;
}
.dashboard-alert button {
  margin-left: auto;
  border: none;
  border-radius: 9px;
  background: #ef4444;
  color: #ffffff;
  padding: 7px 12px;
  font-size: 12px;
  font-weight: 800;
  cursor: pointer;
}
.dashboard-alert button:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* =========================================================
   PARTIAL API WARNING
========================================================= */
.dashboard-partial-warning {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 12px;
  padding: 10px 13px;
  border: 1px solid rgba(245, 158, 11, 0.22);
  border-radius: 13px;
  background: rgba(255, 251, 235, 0.95);
  color: #92400e;
}
.dashboard-partial-warning .dashboard-warning-icon {
  width: 27px;
  height: 27px;
  display: grid;
  place-items: center;
  flex: 0 0 27px;
  border-radius: 50%;
  background: rgba(245, 158, 11, 0.14);
  color: #d97706;
  font-size: 13px;
  font-weight: 900;
}
.dashboard-partial-warning > div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.dashboard-partial-warning strong {
  font-size: 12px;
  line-height: 1.3;
  font-weight: 800;
}
.dashboard-partial-warning small {
  color: #a16207;
  font-size: 11px;
  line-height: 1.35;
  font-weight: 550;
}

/* =========================================================
   SUMMARY BAR
========================================================= */
.dashboard-summary-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  padding: 18px 20px;
  border-radius: 22px;
  background: #ffffff;
  color: #ffffff;
  box-shadow: 0 16px 38px rgba(15, 23, 42, 0.16);
}
.dashboard-summary-bar span {
  display: inline-flex;
  width: fit-content;
  padding: 6px 10px;
  border: 1px solid #828586;
  border-radius: 999px;
  color: #828586;
  font-size: 11px;
  font-weight: 660;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.dashboard-summary-bar h2 {
  margin: 10px 0 0;
  font-size: 24px;
  line-height: 1.12;
  font-weight: 660;
  letter-spacing: 0.4px;
}

.summary-percent {
  min-width: 150px;
  padding: 14px 16px;
  border: 1px solid rgba(0, 0, 0, 0.16);
  border-radius: 18px;
  background: rgba(138, 138, 138, 0.08);
}
.summary-percent small {
  display: block;
  color: #828586;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.8px;
}
.summary-percent strong {
  display: block;
  margin-top: 4px;
  font-size: 30px;
  line-height: 1;
  font-weight: 950;
  letter-spacing: -1px;
}

/* =========================================================
   COMPACT CARD GRID
========================================================= */
.compact-card-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
  margin-top: 16px;
}

/* =========================================================
   COMPACT KPI CARD
========================================================= */
.compact-metric-card {
  min-width: 0;
  min-height: 176px;
  padding: 14px;
  border: 1px solid #e5eaf2;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.055);
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;
}
.compact-metric-card:hover {
  transform: translateY(-3px);
  border-color: #cbd5e1;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.09);
}

.card-main-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.metric-icon-box {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: grid;
  place-items: center;
  border-radius: 14px;
}
.metric-icon-box span {
  font-size: 28px;
  line-height: 1;
}

.metric-content {
  min-width: 0;
  flex: 1 1;
}
.metric-content h3 {
  margin: 0;
  overflow: hidden;
  color: #111827;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 640;
  letter-spacing: -0.15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.metric-content .metric-value {
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-top: 12px;
}
.metric-content .metric-value strong {
  overflow: hidden;
  max-width: 100%;
  color: #030712;
  font-size: 24px;
  line-height: 1;
  font-weight: 600;
  text-overflow: ellipsis;
}
.metric-content .metric-value span {
  color: #111827;
  font-size: 16px;
  font-weight: 600;
}

.card-bottom-row {
  min-width: 0;
  flex: 1 1;
  display: flex;
  align-items: baseline;
  gap: 5px;
  margin-top: 12px;
}
.card-bottom-row p {
  margin: 9px 0 0;
  color: #475569;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 600;
}
.card-bottom-row .danger-text {
  color: #dc2626;
  font-size: 16px;
  font-weight: 680;
}

.mini-progress-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mini-progress-track {
  overflow: hidden;
  flex: 1 1;
  height: 7px;
  border-radius: 999px;
  background: #e8edf5;
}

.mini-progress-fill {
  height: 100%;
  border-radius: inherit;
  transition: width 0.65s ease;
}

.mini-progress-value {
  min-width: 42px;
  text-align: right;
  color: #111827;
  font-size: 18px;
  font-weight: 700;
}

/* =========================================================
   KPI CARD COLORS
========================================================= */
.compact-metric-card.blue .metric-icon-box {
  background: #eaf2ff;
  color: #2563eb;
}
.compact-metric-card.blue .mini-progress-fill {
  background: linear-gradient(90deg, #2563eb, #0ea5e9);
}

.compact-metric-card.green .metric-icon-box {
  background: #e9f9f1;
  color: #16a34a;
}
.compact-metric-card.green .mini-progress-fill {
  background: linear-gradient(90deg, #16a34a, #22c55e);
}

.compact-metric-card.purple .metric-icon-box {
  background: #f1ecff;
  color: #7c3aed;
}
.compact-metric-card.purple .mini-progress-fill {
  background: linear-gradient(90deg, #6d28d9, #8b5cf6);
}

.compact-metric-card.red .metric-icon-box {
  background: #fff0f0;
  color: #ef4444;
}
.compact-metric-card.red .mini-progress-fill {
  background: linear-gradient(90deg, #ef4444, #fb7185);
}

.compact-metric-card.orange .metric-icon-box {
  background: #fff7e7;
  color: #f59e0b;
}
.compact-metric-card.orange .mini-progress-fill {
  background: linear-gradient(90deg, #f59e0b, #f97316);
}

.compact-metric-card.cyan .metric-icon-box {
  background: #e8fbff;
  color: #0891b2;
}
.compact-metric-card.cyan .mini-progress-fill {
  background: linear-gradient(90deg, #0891b2, #06b6d4);
}

/* =========================================================
   BACKGROUND REFRESH EFFECT
========================================================= */
/*
 * Existing content stays fully visible.
 *
 * We only add a tiny transition to indicate that fresh data
 * is being loaded, without making charts hard to read.
 */
.dashboard-content-wrapper {
  transition: opacity 0.2s ease, filter 0.2s ease;
}
.dashboard-content-wrapper.is-background-refreshing {
  opacity: 0.985;
}

/* =========================================================
   SKELETON
========================================================= */
.compact-skeleton-card {
  min-height: 176px;
  padding: 14px;
  border: 1px solid #e5eaf2;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.055);
}
.compact-skeleton-card span,
.compact-skeleton-card b,
.compact-skeleton-card .skeleton-progress {
  display: block;
  border-radius: 999px;
  background: linear-gradient(90deg, #eef2f7, #f8fafc, #eef2f7);
  background-size: 220% 100%;
  animation: skeletonLoading 1.1s ease-in-out infinite;
}

.skeleton-top {
  display: flex;
  gap: 12px;
}
.skeleton-top span {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  border-radius: 14px;
}
.skeleton-top div {
  flex: 1 1;
}
.skeleton-top b:first-child {
  width: 85%;
  height: 14px;
}
.skeleton-top b:last-child {
  width: 60%;
  height: 28px;
  margin-top: 18px;
}

.skeleton-progress {
  width: 100%;
  height: 7px;
  margin-top: 32px;
}

@keyframes skeletonLoading {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}
/* =========================================================
   RESPONSIVE
========================================================= */
@media (max-width: 1500px) {
  .compact-card-grid {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }
}
@media (max-width: 1250px) {
  .compact-card-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 992px) {
  .dashboard-topbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .topbar-filters {
    width: 100%;
    justify-content: flex-start;
  }
  .compact-card-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-summary-bar {
    align-items: flex-start;
    flex-direction: column;
  }
}
@media (max-width: 768px) {
  .dashboard-live-status {
    align-items: flex-start;
  }
  .dashboard-live-status-left {
    align-items: flex-start;
  }
  .dashboard-live-status-left small {
    white-space: normal;
  }
}
@media (max-width: 640px) {
  .dashboard-page {
    padding: 12px;
  }
  .dashboard-topbar {
    border-radius: 18px;
  }
  .topbar-left {
    min-width: 0;
  }
  .topbar-left h1 {
    font-size: 18px;
  }
  .topbar-filters {
    display: grid;
    grid-template-columns: 1fr;
  }
  .field-box input,
  .field-box.target-box input {
    width: 100%;
  }
  .refresh-button {
    width: 100%;
  }
  .dashboard-live-status {
    padding: 10px 12px;
  }
  .dashboard-live-status-right {
    align-self: center;
  }
  .dashboard-summary-bar {
    padding: 16px;
    border-radius: 18px;
  }
  .dashboard-summary-bar h2 {
    font-size: 20px;
  }
  .compact-card-grid {
    grid-template-columns: 1fr;
  }
  .compact-metric-card {
    min-height: 150px;
  }
  .dashboard-alert {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .dashboard-alert button {
    width: 100%;
    margin-left: 0;
  }
}
/* =========================================================
   DASHBOARD HEADER LIVE / REFRESH STATUS
========================================================= */
.dashboard-topbar {
  position: relative;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, background-color 0.25s ease;
}
.dashboard-topbar.is-refreshing {
  border-color: rgba(245, 158, 11, 0.24);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07), 0 0 0 3px rgba(245, 158, 11, 0.035);
}

.topbar-left {
  min-width: 0;
}
.topbar-left .live-badge {
  transition: background 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
}
.topbar-left .live-badge.refreshing {
  background: linear-gradient(135deg, #f59e0b, #ea580c);
  box-shadow: 0 10px 22px rgba(245, 158, 11, 0.24);
}

.topbar-title-content {
  min-width: 0;
  flex: 1 1;
}

.topbar-title-row {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}
.topbar-title-row h1 {
  min-width: 0;
}

.dashboard-header-status {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  min-width: 46px;
  height: 21px;
  padding: 0 8px;
  border-radius: 999px;
  font-size: 11px;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.45px;
  text-transform: uppercase;
}
.dashboard-header-status.is-live {
  border: 1px solid rgba(22, 163, 74, 0.16);
  background: rgba(22, 163, 74, 0.08);
  color: #15803d;
}
.dashboard-header-status.is-refreshing {
  border: 1px solid rgba(245, 158, 11, 0.2);
  background: rgba(245, 158, 11, 0.1);
  color: #b45309;
}

.dashboard-header-refresh-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 8px;
  margin-top: 4px;
}
.dashboard-header-refresh-info strong {
  color: #b45309;
  font-size: 11px;
  line-height: 1.35;
  font-weight: 750;
}
.dashboard-header-refresh-info span {
  color: #64748b;
  font-size: 11px;
  line-height: 1.35;
  font-weight: 550;
}

/* Refresh spinner inside Live badge */
.header-refresh-spinner {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255, 255, 255, 0.36);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: dashboardHeaderSpin 0.75s linear infinite;
}

/* Refresh button spinner */
.refresh-button-spinner {
  width: 17px;
  height: 17px;
  border: 2px solid rgba(255, 255, 255, 0.38);
  border-top-color: #ffffff;
  border-radius: 50%;
  animation: dashboardHeaderSpin 0.75s linear infinite;
}

@keyframes dashboardHeaderSpin {
  to {
    transform: rotate(360deg);
  }
}
/* =========================================================
   RESPONSIVE HEADER STATUS
========================================================= */
@media (max-width: 992px) {
  .topbar-title-row {
    flex-wrap: wrap;
  }
  .dashboard-header-refresh-info {
    align-items: flex-start;
    flex-direction: column;
    gap: 2px;
  }
}
@media (max-width: 640px) {
  .topbar-left {
    width: 100%;
  }
  .topbar-title-row {
    gap: 6px;
  }
  .topbar-title-row h1 {
    font-size: 18px;
  }
  .dashboard-header-status {
    min-width: 42px;
    height: 19px;
    padding: 0 7px;
    font-size: 8px;
  }
  .dashboard-header-refresh-info strong,
  .dashboard-header-refresh-info span {
    font-size: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/pages/manufacturing_app/Dashboard/Dashboard.scss"],"names":[],"mappings":"AAAA,mBAAA;AAEA;EACI,sBAAA;AAAJ;;AAGA;EACI,SAAA;EACA,mBAAA;EACA,cAAA;EAEA,uGACI;AAFR;;AAWA;;EAEI,oBAAA;AARJ;;AAWA;;2DAAA;AAIA;EACI,WAAA;EACA,iBAAA;EAEA,kBAAA;EAEA,oGACI;AAZR;;AAkBA;;2DAAA;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,SAAA;EAEA,WAAA;EAEA,kBAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,qCAAA;EAEA,8CACI;EAEJ,2BAAA;AAxBJ;;AA2BA;EACI,aAAA;EACA,mBAAA;EAEA,SAAA;EAEA,gBAAA;AA1BJ;AA4BI;EACI,WAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EAEA,cAAA;EAEA,mBAAA;EAEA,qDACI;EAIJ,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,+CACI;AArCZ;AAwCI;EACI,SAAA;EAEA,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;AAxCR;AA2CI;EACI,eAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;AA3CR;;AA+CA;EACI,aAAA;EACA,gBAAA;EACA,yBAAA;EAEA,SAAA;EAEA,eAAA;AA9CJ;;AAiDA;EACI,aAAA;EACA,sBAAA;EAEA,QAAA;AA/CJ;AAiDI;EACI,cAAA;EAEA,eAAA;EACA,gBAAA;AAhDR;AAmDI;EACI,YAAA;EACA,YAAA;EAEA,eAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,aAAA;EAEA,mBAAA;EACA,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,0DACI;AAxDZ;AA2DQ;EACI,qBAAA;EAEA,6CACI;AA3DhB;AA+DI;EACI,YAAA;AA7DR;;AAiEA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,gBAAA;EACA,YAAA;EAEA,YAAA;EACA,kBAAA;EAEA,eAAA;EAEA,mBAAA;EACA,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,eAAA;EAEA,iFACI;AAtER;AA0EI;EACI,mBAAA;EAEA,2BAAA;EAEA,2CACI;AA3EZ;AA8EI;EACI,aAAA;EACA,mBAAA;AA5ER;;AAgFA;;2DAAA;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,SAAA;EAEA,gBAAA;EAEA,gBAAA;EAEA,kBAAA;EAEA,wCAAA;EAEA,mBAAA;EAEA,yFACI;EAIJ,8CACI;EAEJ,iFACI;AA5FR;;AAiGA;EACI,aAAA;EACA,mBAAA;EAEA,YAAA;EAEA,SAAA;AAhGJ;AAkGI;EACI,YAAA;EAEA,aAAA;EACA,sBAAA;EAEA,QAAA;AAlGR;AAqGI;EACI,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;AApGR;AAuGI;EACI,gBAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;EACA,gBAAA;EAEA,uBAAA;EACA,mBAAA;AAxGR;;AA4GA;EACI,kBAAA;EAEA,UAAA;EACA,WAAA;EAEA,aAAA;EAEA,kBAAA;EAEA,mBAAA;EAEA,4CACI;EAEJ,kDACI;AAjHR;AAmHI;EACI,mBAAA;EAEA,8CACI;EAEJ,0DACI;AArHZ;;AAyHA;EACI;IACI,2CACI;EAvHV;EA0HE;IACI,0CACI;EAzHV;EA4HE;IACI,wCACI;EA3HV;AACF;AA8HA;EACI;IACI,4CACI;EA7HV;EAgIE;IACI,2CACI;EA/HV;EAkIE;IACI,yCACI;EAjIV;AACF;AAoIA;EACI,aAAA;EACA,mBAAA;EAEA,cAAA;EAEA,QAAA;AApIJ;;AAuIA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,eAAA;EACA,YAAA;EAEA,cAAA;EAEA,oBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,qBAAA;EAEA,yBAAA;AA1IJ;AA4II;EACI,yCAAA;EAEA,mCACI;EAEJ,cAAA;AA7IR;AAgJI;EACI,0CAAA;EAEA,oCACI;EAEJ,cAAA;AAjJR;;AAqJA;EACI,WAAA;EACA,YAAA;EAEA,cAAA;EAEA,yCAAA;EAEA,yBAAA;EAEA,kBAAA;EAEA,qDACI;AAxJR;;AA2JA;EACI;IACI,yBAAA;EAxJN;AACF;AA2JA;;2DAAA;AAIA;EACI,aAAA;EACA,mBAAA;EAEA,QAAA;EAEA,gBAAA;EAEA,kBAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,cAAA;EAEA,eAAA;AAhKJ;AAkKI;EACI,gBAAA;AAhKR;AAmKI;EACI,SAAA;EAEA,gBAAA;AAlKR;AAqKI;EACI,iBAAA;EAEA,YAAA;EACA,kBAAA;EAEA,mBAAA;EACA,cAAA;EAEA,iBAAA;EAEA,eAAA;EACA,gBAAA;EAEA,eAAA;AAxKR;AA0KQ;EACI,aAAA;EACA,mBAAA;AAxKZ;;AA6KA;;2DAAA;AAIA;EACI,aAAA;EACA,mBAAA;EAEA,SAAA;EAEA,gBAAA;EAEA,kBAAA;EAEA,0CAAA;EAEA,mBAAA;EAEA,qCACI;EAEJ,cAAA;AAnLJ;AAqLI;EACI,WAAA;EACA,YAAA;EAEA,aAAA;EACA,mBAAA;EAEA,cAAA;EAEA,kBAAA;EAEA,oCACI;EAEJ,cAAA;EAEA,eAAA;EACA,gBAAA;AA1LR;AA6LI;EACI,aAAA;EACA,sBAAA;EAEA,QAAA;AA5LR;AA+LI;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;AA7LR;AAgMI;EACI,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;AA/LR;;AAmMA;;2DAAA;AAIA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,SAAA;EAEA,gBAAA;EAEA,kBAAA;EAEA,mBAAA;EAEA,mBAAA;EACA,cAAA;EAEA,8CACI;AAxMR;AA0MI;EACI,oBAAA;EAEA,kBAAA;EAEA,iBAAA;EAEA,yBAAA;EACA,oBAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,yBAAA;EACA,mBAAA;AA9MR;AAiNI;EACI,gBAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,qBAAA;AAjNR;;AAqNA;EACI,gBAAA;EAEA,kBAAA;EAEA,qCAAA;EAEA,mBAAA;EAEA,qCACI;AAvNR;AAyNI;EACI,cAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;EAEA,qBAAA;AA1NR;AA6NI;EACI,cAAA;EAEA,eAAA;EAEA,eAAA;EACA,cAAA;EACA,gBAAA;EAEA,oBAAA;AA9NR;;AAkOA;;2DAAA;AAIA;EACI,aAAA;EAEA,gDACI;EAEJ,SAAA;EAEA,gBAAA;AApOJ;;AAuOA;;2DAAA;AAIA;EACI,YAAA;EACA,iBAAA;EAEA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,8CACI;EAEJ,gGACI;AA5OR;AAiPI;EACI,2BAAA;EAEA,qBAAA;EAEA,8CACI;AAlPZ;;AAsPA;EACI,aAAA;EACA,uBAAA;EAEA,SAAA;AApPJ;;AAuPA;EACI,WAAA;EACA,YAAA;EAEA,cAAA;EAEA,aAAA;EACA,mBAAA;EAEA,mBAAA;AAvPJ;AAyPI;EACI,eAAA;EACA,cAAA;AAvPR;;AA2PA;EACI,YAAA;EAEA,SAAA;AAzPJ;AA2PI;EACI,SAAA;EAEA,gBAAA;EAEA,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;EAEA,uBAAA;EAEA,uBAAA;EACA,mBAAA;AA9PR;AAiQI;EACI,aAAA;EACA,qBAAA;EAEA,QAAA;EAEA,gBAAA;AAjQR;AAmQQ;EACI,gBAAA;EAEA,eAAA;EAEA,cAAA;EAEA,eAAA;EACA,cAAA;EACA,gBAAA;EAEA,uBAAA;AArQZ;AAwQQ;EACI,cAAA;EAEA,eAAA;EACA,gBAAA;AAvQZ;;AA4QA;EACI,YAAA;EAEA,SAAA;EAEA,aAAA;EACA,qBAAA;EAEA,QAAA;EAEA,gBAAA;AA7QJ;AA+QI;EACI,eAAA;EAEA,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;AA/QR;AAkRI;EACI,cAAA;EAEA,eAAA;EACA,gBAAA;AAjRR;;AAqRA;EACI,aAAA;EACA,mBAAA;EAEA,SAAA;AAnRJ;;AAsRA;EACI,gBAAA;EAEA,SAAA;EAEA,WAAA;EAEA,oBAAA;EAEA,mBAAA;AAvRJ;;AA0RA;EACI,YAAA;EAEA,sBAAA;EAEA,4BACI;AA1RR;;AA6RA;EACI,eAAA;EAEA,iBAAA;EAEA,cAAA;EAEA,eAAA;EACA,gBAAA;AA7RJ;;AAgSA;;2DAAA;AAKI;EACI,mBAAA;EACA,cAAA;AA/RR;AAkSI;EACI,oDACI;AAjSZ;;AAwSI;EACI,mBAAA;EACA,cAAA;AArSR;AAwSI;EACI,oDACI;AAvSZ;;AA8SI;EACI,mBAAA;EACA,cAAA;AA3SR;AA8SI;EACI,oDACI;AA7SZ;;AAoTI;EACI,mBAAA;EACA,cAAA;AAjTR;AAoTI;EACI,oDACI;AAnTZ;;AA0TI;EACI,mBAAA;EACA,cAAA;AAvTR;AA0TI;EACI,oDACI;AAzTZ;;AAgUI;EACI,mBAAA;EACA,cAAA;AA7TR;AAgUI;EACI,oDACI;AA/TZ;;AAqUA;;2DAAA;AAIA;;;;;EAAA;AAMA;EACI,+CACI;AApUR;AAuUI;EACI,cAAA;AArUR;;AAyUA;;2DAAA;AAIA;EACI,iBAAA;EAEA,aAAA;EAEA,yBAAA;EACA,mBAAA;EAEA,mBAAA;EAEA,8CACI;AA5UR;AA8UI;;;EAGI,cAAA;EAEA,oBAAA;EAEA,6DACI;EAKJ,0BAAA;EAEA,oDACI;AArVZ;;AAyVA;EACI,aAAA;EAEA,SAAA;AAvVJ;AAyVI;EACI,WAAA;EACA,YAAA;EAEA,cAAA;EAEA,mBAAA;AAzVR;AA4VI;EACI,SAAA;AA1VR;AA6VI;EACI,UAAA;EACA,YAAA;AA3VR;AA8VI;EACI,UAAA;EACA,YAAA;EAEA,gBAAA;AA7VR;;AAiWA;EACI,WAAA;EACA,WAAA;EAEA,gBAAA;AA/VJ;;AAkWA;EACI;IACI,2BAAA;EA/VN;EAkWE;IACI,4BAAA;EAhWN;AACF;AAmWA;;2DAAA;AAIA;EACI;IACI,gDACI;EAnWV;AACF;AAsWA;EACI;IACI,gDACI;EArWV;AACF;AAwWA;EACI;IACI,uBAAA;IACA,sBAAA;EAtWN;EAyWE;IACI,WAAA;IAEA,2BAAA;EAxWN;EA2WE;IACI,gDACI;EA1WV;EA6WE;IACI,uBAAA;IACA,sBAAA;EA3WN;AACF;AA8WA;EACI;IACI,uBAAA;EA5WN;EA+WE;IACI,uBAAA;EA7WN;EA+WM;IACI,mBAAA;EA7WV;AACF;AAiXA;EACI;IACI,aAAA;EA/WN;EAkXE;IACI,mBAAA;EAhXN;EAmXE;IACI,YAAA;EAjXN;EAmXM;IACI,eAAA;EAjXV;EAqXE;IACI,aAAA;IAEA,0BAAA;EApXN;EAyXM;;IACI,WAAA;EAtXV;EA0XE;IACI,WAAA;EAxXN;EA2XE;IACI,kBAAA;EAzXN;EA4XE;IACI,kBAAA;EA1XN;EA6XE;IACI,aAAA;IAEA,mBAAA;EA5XN;EA8XM;IACI,eAAA;EA5XV;EAgYE;IACI,0BAAA;EA9XN;EAiYE;IACI,iBAAA;EA/XN;EAkYE;IACI,uBAAA;IACA,eAAA;EAhYN;EAkYM;IACI,WAAA;IAEA,cAAA;EAjYV;AACF;AAuYA;;2DAAA;AAIA;EACI,kBAAA;EAEA,uFACI;AAxYR;AA4YI;EACI,sCAAA;EAEA,mFACI;AA5YZ;;AAiZA;EACI,YAAA;AA9YJ;AAgZI;EACI,8EACI;AA/YZ;AAmZQ;EACI,qDACI;EAMJ,gDACI;AAxZhB;;AA8ZA;EACI,YAAA;EAEA,SAAA;AA5ZJ;;AA+ZA;EACI,aAAA;EACA,mBAAA;EAEA,QAAA;EAEA,YAAA;AA9ZJ;AAgaI;EACI,YAAA;AA9ZR;;AAkaA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cAAA;EAEA,eAAA;EACA,YAAA;EAEA,cAAA;EAEA,oBAAA;EAEA,eAAA;EACA,cAAA;EACA,gBAAA;EAEA,sBAAA;EAEA,yBAAA;AAtaJ;AAwaI;EACI,yCAAA;EAGA,mCACI;EAEJ,cAAA;AA1aR;AA6aI;EACI,yCAAA;EAGA,mCACI;EAEJ,cAAA;AA/aR;;AAmbA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,YAAA;EAEA,eAAA;AAlbJ;AAobI;EACI,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;AAnbR;AAsbI;EACI,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;AArbR;;AAybA,sCAAA;AAEA;EACI,WAAA;EACA,YAAA;EAEA,2CAAA;EAGA,yBAAA;EAEA,kBAAA;EAEA,oDACI;AA7bR;;AAicA,2BAAA;AAEA;EACI,WAAA;EACA,YAAA;EAEA,2CAAA;EAGA,yBAAA;EAEA,kBAAA;EAEA,oDACI;AArcR;;AAycA;EACI;IACI,yBAAA;EAtcN;AACF;AAycA;;2DAAA;AAIA;EACI;IACI,eAAA;EAxcN;EA2cE;IACI,uBAAA;IACA,sBAAA;IAEA,QAAA;EA1cN;AACF;AA6cA;EACI;IACI,WAAA;EA3cN;EA8cE;IACI,QAAA;EA5cN;EA8cM;IACI,eAAA;EA5cV;EAgdE;IACI,eAAA;IACA,YAAA;IAEA,cAAA;IAEA,cAAA;EAhdN;EAodM;;IAEI,eAAA;EAldV;AACF","sourcesContent":["/* Dashboard.scss */\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    margin: 0;\n    background: #f6f8fc;\n    color: #111827;\n\n    font-family:\n        Inter,\n        ui-sans-serif,\n        system-ui,\n        -apple-system,\n        BlinkMacSystemFont,\n        \"Segoe UI\",\n        sans-serif;\n}\n\nbutton,\ninput {\n    font-family: inherit;\n}\n\n/* =========================================================\n   DASHBOARD PAGE\n========================================================= */\n\n.dashboard-page {\n    width: 100%;\n    min-height: 100vh;\n\n    padding: 16px 18px;\n\n    background:\n        radial-gradient(circle at top right,\n            rgba(37, 99, 235, 0.035),\n            transparent 28%),\n        #f6f8fc;\n}\n\n/* =========================================================\n   HEADER\n========================================================= */\n\n.dashboard-topbar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    gap: 16px;\n\n    width: 100%;\n\n    padding: 14px 16px;\n\n    border: 1px solid #e6edf7;\n    border-radius: 22px;\n\n    background: rgba(255, 255, 255, 0.94);\n\n    box-shadow:\n        0 12px 30px rgba(15, 23, 42, 0.07);\n\n    backdrop-filter: blur(14px);\n}\n\n.topbar-left {\n    display: flex;\n    align-items: center;\n\n    gap: 12px;\n\n    min-width: 280px;\n\n    .live-badge {\n        width: 46px;\n        height: 46px;\n\n        display: grid;\n        place-items: center;\n\n        flex: 0 0 46px;\n\n        border-radius: 15px;\n\n        background:\n            linear-gradient(135deg,\n                #0ea5e9,\n                #2563eb);\n\n        color: #ffffff;\n\n        font-size: 12px;\n        font-weight: 900;\n\n        box-shadow:\n            0 10px 22px rgba(37, 99, 235, 0.24);\n    }\n\n    h1 {\n        margin: 0;\n\n        color: #111827;\n\n        font-size: 24px;\n        line-height: 1.15;\n        font-weight: 700;\n    }\n\n    p {\n        margin: 4px 0 0;\n\n        color: #64748b;\n\n        font-size: 12px;\n        font-weight: 650;\n    }\n}\n\n.topbar-filters {\n    display: flex;\n    align-items: end;\n    justify-content: flex-end;\n\n    gap: 10px;\n\n    flex-wrap: wrap;\n}\n\n.field-box {\n    display: flex;\n    flex-direction: column;\n\n    gap: 5px;\n\n    label {\n        color: #3f4a5b;\n\n        font-size: 12px;\n        font-weight: 700;\n    }\n\n    input {\n        width: 140px;\n        height: 36px;\n\n        padding: 0 10px;\n\n        border: 1px solid #d7e0ed;\n        border-radius: 10px;\n\n        outline: none;\n\n        background: #ffffff;\n        color: #111827;\n\n        font-size: 12px;\n        font-weight: 750;\n\n        transition:\n            border-color 0.18s ease,\n            box-shadow 0.18s ease;\n\n        &:focus {\n            border-color: #2563eb;\n\n            box-shadow:\n                0 0 0 3px rgba(37, 99, 235, 0.12);\n        }\n    }\n\n    &.target-box input {\n        width: 160px;\n    }\n}\n\n.refresh-button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    min-width: 100px;\n    height: 36px;\n\n    border: none;\n    border-radius: 8px;\n\n    padding: 0 16px;\n\n    background: #0047ab;\n    color: #ffffff;\n\n    font-size: 14px;\n    font-weight: 700;\n\n    cursor: pointer;\n\n    transition:\n        background-color 0.2s ease,\n        transform 0.2s ease,\n        box-shadow 0.2s ease;\n\n    &:hover:not(:disabled) {\n        background: #020617;\n\n        transform: translateY(-1px);\n\n        box-shadow:\n            0 7px 18px rgba(2, 6, 23, 0.15);\n    }\n\n    &:disabled {\n        opacity: 0.65;\n        cursor: not-allowed;\n    }\n}\n\n/* =========================================================\n   LIVE DASHBOARD STATUS\n========================================================= */\n\n.dashboard-live-status {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    gap: 16px;\n\n    min-height: 58px;\n\n    margin-top: 12px;\n\n    padding: 10px 14px;\n\n    border: 1px solid rgba(37, 99, 235, 0.1);\n\n    border-radius: 14px;\n\n    background:\n        linear-gradient(135deg,\n            rgba(255, 255, 255, 0.98),\n            rgba(239, 246, 255, 0.72));\n\n    box-shadow:\n        0 5px 16px rgba(15, 23, 42, 0.035);\n\n    transition:\n        border-color 0.25s ease,\n        background 0.25s ease,\n        box-shadow 0.25s ease;\n}\n\n.dashboard-live-status-left {\n    display: flex;\n    align-items: center;\n\n    min-width: 0;\n\n    gap: 11px;\n\n    >div {\n        min-width: 0;\n\n        display: flex;\n        flex-direction: column;\n\n        gap: 2px;\n    }\n\n    strong {\n        color: #0f172a;\n\n        font-size: 12px;\n        line-height: 1.35;\n        font-weight: 750;\n    }\n\n    small {\n        overflow: hidden;\n\n        color: #64748b;\n\n        font-size: 11px;\n        line-height: 1.4;\n        font-weight: 550;\n\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n}\n\n.dashboard-live-dot {\n    position: relative;\n\n    width: 9px;\n    height: 9px;\n\n    flex: 0 0 9px;\n\n    border-radius: 50%;\n\n    background: #16a34a;\n\n    box-shadow:\n        0 0 0 4px rgba(22, 163, 74, 0.1);\n\n    animation:\n        dashboardLivePulse 2s ease-out infinite;\n\n    &.refreshing {\n        background: #f59e0b;\n\n        box-shadow:\n            0 0 0 4px rgba(245, 158, 11, 0.12);\n\n        animation:\n            dashboardRefreshingPulse 1.2s ease-out infinite;\n    }\n}\n\n@keyframes dashboardLivePulse {\n    0% {\n        box-shadow:\n            0 0 0 0 rgba(22, 163, 74, 0.32);\n    }\n\n    70% {\n        box-shadow:\n            0 0 0 8px rgba(22, 163, 74, 0);\n    }\n\n    100% {\n        box-shadow:\n            0 0 0 0 rgba(22, 163, 74, 0);\n    }\n}\n\n@keyframes dashboardRefreshingPulse {\n    0% {\n        box-shadow:\n            0 0 0 0 rgba(245, 158, 11, 0.34);\n    }\n\n    70% {\n        box-shadow:\n            0 0 0 8px rgba(245, 158, 11, 0);\n    }\n\n    100% {\n        box-shadow:\n            0 0 0 0 rgba(245, 158, 11, 0);\n    }\n}\n\n.dashboard-live-status-right {\n    display: flex;\n    align-items: center;\n\n    flex-shrink: 0;\n\n    gap: 9px;\n}\n\n.dashboard-refresh-state {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    min-width: 55px;\n    height: 25px;\n\n    padding: 0 9px;\n\n    border-radius: 999px;\n\n    font-size: 10px;\n    font-weight: 800;\n\n    letter-spacing: 0.3px;\n\n    text-transform: uppercase;\n\n    &.is-live {\n        border: 1px solid rgba(22, 163, 74, 0.15);\n\n        background:\n            rgba(22, 163, 74, 0.08);\n\n        color: #15803d;\n    }\n\n    &.is-refreshing {\n        border: 1px solid rgba(245, 158, 11, 0.18);\n\n        background:\n            rgba(245, 158, 11, 0.09);\n\n        color: #b45309;\n    }\n}\n\n.dashboard-refresh-spinner {\n    width: 17px;\n    height: 17px;\n\n    flex: 0 0 17px;\n\n    border: 2px solid rgba(37, 99, 235, 0.18);\n\n    border-top-color: #2563eb;\n\n    border-radius: 50%;\n\n    animation:\n        dashboardRefreshSpin 0.75s linear infinite;\n}\n\n@keyframes dashboardRefreshSpin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* =========================================================\n   API ERROR ALERT\n========================================================= */\n\n.dashboard-alert {\n    display: flex;\n    align-items: center;\n\n    gap: 8px;\n\n    margin-top: 12px;\n\n    padding: 10px 12px;\n\n    border: 1px solid #fecdd3;\n    border-radius: 14px;\n\n    background: #fff1f2;\n    color: #991b1b;\n\n    font-size: 13px;\n\n    strong {\n        font-weight: 900;\n    }\n\n    span {\n        flex: 1;\n\n        font-weight: 600;\n    }\n\n    button {\n        margin-left: auto;\n\n        border: none;\n        border-radius: 9px;\n\n        background: #ef4444;\n        color: #ffffff;\n\n        padding: 7px 12px;\n\n        font-size: 12px;\n        font-weight: 800;\n\n        cursor: pointer;\n\n        &:disabled {\n            opacity: 0.65;\n            cursor: not-allowed;\n        }\n    }\n}\n\n/* =========================================================\n   PARTIAL API WARNING\n========================================================= */\n\n.dashboard-partial-warning {\n    display: flex;\n    align-items: center;\n\n    gap: 10px;\n\n    margin-top: 12px;\n\n    padding: 10px 13px;\n\n    border: 1px solid rgba(245, 158, 11, 0.22);\n\n    border-radius: 13px;\n\n    background:\n        rgba(255, 251, 235, 0.95);\n\n    color: #92400e;\n\n    .dashboard-warning-icon {\n        width: 27px;\n        height: 27px;\n\n        display: grid;\n        place-items: center;\n\n        flex: 0 0 27px;\n\n        border-radius: 50%;\n\n        background:\n            rgba(245, 158, 11, 0.14);\n\n        color: #d97706;\n\n        font-size: 13px;\n        font-weight: 900;\n    }\n\n    >div {\n        display: flex;\n        flex-direction: column;\n\n        gap: 2px;\n    }\n\n    strong {\n        font-size: 12px;\n        line-height: 1.3;\n        font-weight: 800;\n    }\n\n    small {\n        color: #a16207;\n\n        font-size: 11px;\n        line-height: 1.35;\n        font-weight: 550;\n    }\n}\n\n/* =========================================================\n   SUMMARY BAR\n========================================================= */\n\n.dashboard-summary-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    gap: 16px;\n\n    margin-top: 16px;\n\n    padding: 18px 20px;\n\n    border-radius: 22px;\n\n    background: #ffffff;\n    color: #ffffff;\n\n    box-shadow:\n        0 16px 38px rgba(15, 23, 42, 0.16);\n\n    span {\n        display: inline-flex;\n\n        width: fit-content;\n\n        padding: 6px 10px;\n\n        border: 1px solid #828586;\n        border-radius: 999px;\n\n        color: #828586;\n\n        font-size: 11px;\n        font-weight: 660;\n\n        text-transform: uppercase;\n        letter-spacing: 1px;\n    }\n\n    h2 {\n        margin: 10px 0 0;\n\n        font-size: 24px;\n        line-height: 1.12;\n        font-weight: 660;\n\n        letter-spacing: 0.4px;\n    }\n}\n\n.summary-percent {\n    min-width: 150px;\n\n    padding: 14px 16px;\n\n    border: 1px solid rgb(0 0 0 / 16%);\n\n    border-radius: 18px;\n\n    background:\n        rgb(138 138 138 / 8%);\n\n    small {\n        display: block;\n\n        color: #828586;\n\n        font-size: 11px;\n        font-weight: 750;\n\n        letter-spacing: 0.8px;\n    }\n\n    strong {\n        display: block;\n\n        margin-top: 4px;\n\n        font-size: 30px;\n        line-height: 1;\n        font-weight: 950;\n\n        letter-spacing: -1px;\n    }\n}\n\n/* =========================================================\n   COMPACT CARD GRID\n========================================================= */\n\n.compact-card-grid {\n    display: grid;\n\n    grid-template-columns:\n        repeat(6, minmax(0, 1fr));\n\n    gap: 12px;\n\n    margin-top: 16px;\n}\n\n/* =========================================================\n   COMPACT KPI CARD\n========================================================= */\n\n.compact-metric-card {\n    min-width: 0;\n    min-height: 176px;\n\n    padding: 14px;\n\n    border: 1px solid #e5eaf2;\n    border-radius: 16px;\n\n    background: #ffffff;\n\n    box-shadow:\n        0 8px 24px rgba(15, 23, 42, 0.055);\n\n    transition:\n        transform 0.2s ease,\n        box-shadow 0.2s ease,\n        border-color 0.2s ease,\n        opacity 0.2s ease;\n\n    &:hover {\n        transform: translateY(-3px);\n\n        border-color: #cbd5e1;\n\n        box-shadow:\n            0 14px 32px rgba(15, 23, 42, 0.09);\n    }\n}\n\n.card-main-row {\n    display: flex;\n    align-items: flex-start;\n\n    gap: 12px;\n}\n\n.metric-icon-box {\n    width: 44px;\n    height: 44px;\n\n    flex: 0 0 44px;\n\n    display: grid;\n    place-items: center;\n\n    border-radius: 14px;\n\n    span {\n        font-size: 28px;\n        line-height: 1;\n    }\n}\n\n.metric-content {\n    min-width: 0;\n\n    flex: 1;\n\n    h3 {\n        margin: 0;\n\n        overflow: hidden;\n\n        color: #111827;\n\n        font-size: 16px;\n        line-height: 1.25;\n        font-weight: 640;\n\n        letter-spacing: -0.15px;\n\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    .metric-value {\n        display: flex;\n        align-items: baseline;\n\n        gap: 5px;\n\n        margin-top: 12px;\n\n        strong {\n            overflow: hidden;\n\n            max-width: 100%;\n\n            color: #030712;\n\n            font-size: 24px;\n            line-height: 1;\n            font-weight: 600;\n\n            text-overflow: ellipsis;\n        }\n\n        span {\n            color: #111827;\n\n            font-size: 16px;\n            font-weight: 600;\n        }\n    }\n}\n\n.card-bottom-row {\n    min-width: 0;\n\n    flex: 1;\n\n    display: flex;\n    align-items: baseline;\n\n    gap: 5px;\n\n    margin-top: 12px;\n\n    p {\n        margin: 9px 0 0;\n\n        color: #475569;\n\n        font-size: 15px;\n        line-height: 1.35;\n        font-weight: 600;\n    }\n\n    .danger-text {\n        color: #dc2626;\n\n        font-size: 16px;\n        font-weight: 680;\n    }\n}\n\n.mini-progress-row {\n    display: flex;\n    align-items: center;\n\n    gap: 10px;\n}\n\n.mini-progress-track {\n    overflow: hidden;\n\n    flex: 1;\n\n    height: 7px;\n\n    border-radius: 999px;\n\n    background: #e8edf5;\n}\n\n.mini-progress-fill {\n    height: 100%;\n\n    border-radius: inherit;\n\n    transition:\n        width 0.65s ease;\n}\n\n.mini-progress-value {\n    min-width: 42px;\n\n    text-align: right;\n\n    color: #111827;\n\n    font-size: 18px;\n    font-weight: 700;\n}\n\n/* =========================================================\n   KPI CARD COLORS\n========================================================= */\n\n.compact-metric-card.blue {\n    .metric-icon-box {\n        background: #eaf2ff;\n        color: #2563eb;\n    }\n\n    .mini-progress-fill {\n        background:\n            linear-gradient(90deg,\n                #2563eb,\n                #0ea5e9);\n    }\n}\n\n.compact-metric-card.green {\n    .metric-icon-box {\n        background: #e9f9f1;\n        color: #16a34a;\n    }\n\n    .mini-progress-fill {\n        background:\n            linear-gradient(90deg,\n                #16a34a,\n                #22c55e);\n    }\n}\n\n.compact-metric-card.purple {\n    .metric-icon-box {\n        background: #f1ecff;\n        color: #7c3aed;\n    }\n\n    .mini-progress-fill {\n        background:\n            linear-gradient(90deg,\n                #6d28d9,\n                #8b5cf6);\n    }\n}\n\n.compact-metric-card.red {\n    .metric-icon-box {\n        background: #fff0f0;\n        color: #ef4444;\n    }\n\n    .mini-progress-fill {\n        background:\n            linear-gradient(90deg,\n                #ef4444,\n                #fb7185);\n    }\n}\n\n.compact-metric-card.orange {\n    .metric-icon-box {\n        background: #fff7e7;\n        color: #f59e0b;\n    }\n\n    .mini-progress-fill {\n        background:\n            linear-gradient(90deg,\n                #f59e0b,\n                #f97316);\n    }\n}\n\n.compact-metric-card.cyan {\n    .metric-icon-box {\n        background: #e8fbff;\n        color: #0891b2;\n    }\n\n    .mini-progress-fill {\n        background:\n            linear-gradient(90deg,\n                #0891b2,\n                #06b6d4);\n    }\n}\n\n/* =========================================================\n   BACKGROUND REFRESH EFFECT\n========================================================= */\n\n/*\n * Existing content stays fully visible.\n *\n * We only add a tiny transition to indicate that fresh data\n * is being loaded, without making charts hard to read.\n */\n.dashboard-content-wrapper {\n    transition:\n        opacity 0.2s ease,\n        filter 0.2s ease;\n\n    &.is-background-refreshing {\n        opacity: 0.985;\n    }\n}\n\n/* =========================================================\n   SKELETON\n========================================================= */\n\n.compact-skeleton-card {\n    min-height: 176px;\n\n    padding: 14px;\n\n    border: 1px solid #e5eaf2;\n    border-radius: 16px;\n\n    background: #ffffff;\n\n    box-shadow:\n        0 8px 24px rgba(15, 23, 42, 0.055);\n\n    span,\n    b,\n    .skeleton-progress {\n        display: block;\n\n        border-radius: 999px;\n\n        background:\n            linear-gradient(90deg,\n                #eef2f7,\n                #f8fafc,\n                #eef2f7);\n\n        background-size: 220% 100%;\n\n        animation:\n            skeletonLoading 1.1s ease-in-out infinite;\n    }\n}\n\n.skeleton-top {\n    display: flex;\n\n    gap: 12px;\n\n    span {\n        width: 44px;\n        height: 44px;\n\n        flex: 0 0 44px;\n\n        border-radius: 14px;\n    }\n\n    div {\n        flex: 1;\n    }\n\n    b:first-child {\n        width: 85%;\n        height: 14px;\n    }\n\n    b:last-child {\n        width: 60%;\n        height: 28px;\n\n        margin-top: 18px;\n    }\n}\n\n.skeleton-progress {\n    width: 100%;\n    height: 7px;\n\n    margin-top: 32px;\n}\n\n@keyframes skeletonLoading {\n    0% {\n        background-position: 100% 0;\n    }\n\n    100% {\n        background-position: -100% 0;\n    }\n}\n\n/* =========================================================\n   RESPONSIVE\n========================================================= */\n\n@media (max-width: 1500px) {\n    .compact-card-grid {\n        grid-template-columns:\n            repeat(6, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 1250px) {\n    .compact-card-grid {\n        grid-template-columns:\n            repeat(3, minmax(0, 1fr));\n    }\n}\n\n@media (max-width: 992px) {\n    .dashboard-topbar {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n\n    .topbar-filters {\n        width: 100%;\n\n        justify-content: flex-start;\n    }\n\n    .compact-card-grid {\n        grid-template-columns:\n            repeat(2, minmax(0, 1fr));\n    }\n\n    .dashboard-summary-bar {\n        align-items: flex-start;\n        flex-direction: column;\n    }\n}\n\n@media (max-width: 768px) {\n    .dashboard-live-status {\n        align-items: flex-start;\n    }\n\n    .dashboard-live-status-left {\n        align-items: flex-start;\n\n        small {\n            white-space: normal;\n        }\n    }\n}\n\n@media (max-width: 640px) {\n    .dashboard-page {\n        padding: 12px;\n    }\n\n    .dashboard-topbar {\n        border-radius: 18px;\n    }\n\n    .topbar-left {\n        min-width: 0;\n\n        h1 {\n            font-size: 18px;\n        }\n    }\n\n    .topbar-filters {\n        display: grid;\n\n        grid-template-columns: 1fr;\n    }\n\n    .field-box,\n    .field-box.target-box {\n        input {\n            width: 100%;\n        }\n    }\n\n    .refresh-button {\n        width: 100%;\n    }\n\n    .dashboard-live-status {\n        padding: 10px 12px;\n    }\n\n    .dashboard-live-status-right {\n        align-self: center;\n    }\n\n    .dashboard-summary-bar {\n        padding: 16px;\n\n        border-radius: 18px;\n\n        h2 {\n            font-size: 20px;\n        }\n    }\n\n    .compact-card-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .compact-metric-card {\n        min-height: 150px;\n    }\n\n    .dashboard-alert {\n        align-items: flex-start;\n        flex-wrap: wrap;\n\n        button {\n            width: 100%;\n\n            margin-left: 0;\n        }\n    }\n}\n\n\n\n/* =========================================================\n   DASHBOARD HEADER LIVE / REFRESH STATUS\n========================================================= */\n\n.dashboard-topbar {\n    position: relative;\n\n    transition:\n        border-color 0.25s ease,\n        box-shadow 0.25s ease,\n        background-color 0.25s ease;\n\n    &.is-refreshing {\n        border-color: rgba(245, 158, 11, 0.24);\n\n        box-shadow:\n            0 12px 30px rgba(15, 23, 42, 0.07),\n            0 0 0 3px rgba(245, 158, 11, 0.035);\n    }\n}\n\n.topbar-left {\n    min-width: 0;\n\n    .live-badge {\n        transition:\n            background 0.25s ease,\n            box-shadow 0.25s ease,\n            transform 0.25s ease;\n\n        &.refreshing {\n            background:\n                linear-gradient(\n                    135deg,\n                    #f59e0b,\n                    #ea580c\n                );\n\n            box-shadow:\n                0 10px 22px\n                rgba(245, 158, 11, 0.24);\n        }\n    }\n}\n\n.topbar-title-content {\n    min-width: 0;\n\n    flex: 1;\n}\n\n.topbar-title-row {\n    display: flex;\n    align-items: center;\n\n    gap: 9px;\n\n    min-width: 0;\n\n    h1 {\n        min-width: 0;\n    }\n}\n\n.dashboard-header-status {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    flex: 0 0 auto;\n\n    min-width: 46px;\n    height: 21px;\n\n    padding: 0 8px;\n\n    border-radius: 999px;\n\n    font-size: 11px;\n    line-height: 1;\n    font-weight: 700;\n\n    letter-spacing: 0.45px;\n\n    text-transform: uppercase;\n\n    &.is-live {\n        border: 1px solid\n            rgba(22, 163, 74, 0.16);\n\n        background:\n            rgba(22, 163, 74, 0.08);\n\n        color: #15803d;\n    }\n\n    &.is-refreshing {\n        border: 1px solid\n            rgba(245, 158, 11, 0.2);\n\n        background:\n            rgba(245, 158, 11, 0.1);\n\n        color: #b45309;\n    }\n}\n\n.dashboard-header-refresh-info {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n\n    gap: 4px 8px;\n\n    margin-top: 4px;\n\n    strong {\n        color: #b45309;\n\n        font-size: 11px;\n        line-height: 1.35;\n        font-weight: 750;\n    }\n\n    span {\n        color: #64748b;\n\n        font-size: 11px;\n        line-height: 1.35;\n        font-weight: 550;\n    }\n}\n\n/* Refresh spinner inside Live badge */\n\n.header-refresh-spinner {\n    width: 18px;\n    height: 18px;\n\n    border: 2px solid\n        rgba(255, 255, 255, 0.36);\n\n    border-top-color: #ffffff;\n\n    border-radius: 50%;\n\n    animation:\n        dashboardHeaderSpin\n        0.75s linear infinite;\n}\n\n/* Refresh button spinner */\n\n.refresh-button-spinner {\n    width: 17px;\n    height: 17px;\n\n    border: 2px solid\n        rgba(255, 255, 255, 0.38);\n\n    border-top-color: #ffffff;\n\n    border-radius: 50%;\n\n    animation:\n        dashboardHeaderSpin\n        0.75s linear infinite;\n}\n\n@keyframes dashboardHeaderSpin {\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* =========================================================\n   RESPONSIVE HEADER STATUS\n========================================================= */\n\n@media (max-width: 992px) {\n    .topbar-title-row {\n        flex-wrap: wrap;\n    }\n\n    .dashboard-header-refresh-info {\n        align-items: flex-start;\n        flex-direction: column;\n\n        gap: 2px;\n    }\n}\n\n@media (max-width: 640px) {\n    .topbar-left {\n        width: 100%;\n    }\n\n    .topbar-title-row {\n        gap: 6px;\n\n        h1 {\n            font-size: 18px;\n        }\n    }\n\n    .dashboard-header-status {\n        min-width: 42px;\n        height: 19px;\n\n        padding: 0 7px;\n\n        font-size: 8px;\n    }\n\n    .dashboard-header-refresh-info {\n        strong,\n        span {\n            font-size: 10px;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
